<template>
  <tabs parent="ip_addressing">
    <tab id="list" :name="translate('ip_profile.ip-address')" :href="url+'list'" >
      <List />
    </tab>

    <tab id="history" :name="translate('addresses.history')" :href="url+'history'" >
      <History />
    </tab>

  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import History from './Tabs/History/Index.vue'
import List from './Tabs/List/Index.vue'

export default {
  name: 'IP-addressing',
  components:{
    Tab,
    Tabs,
    List,
    History,
  },
  props: {
  },
  data () {
    return {
      load: true,
    }
  },
  computed: {
    url () { return '/ip_addressing/' }
  },

}
</script>
